module.exports = __webpack_public_path__ + "static/media/20180825_143918.62ba4a81.jpg";